














import Vue from "vue";
import { createComponent } from "@vue/composition-api";
import { formValidator } from "@/shared/formValidator";
import { required } from "@/shared/validationRules";

const validationRules = {
  name: required,
};

export default createComponent({
  components: {},
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  setup(props, ctx) {
    return {
      ...formValidator(),
      validationRules,
    };
  },
});
